import React from 'react'
import { Button, Text } from 'shared-ui/components'
import { backBtn } from 'shared-ui/assets'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

const BackButton = ({
  pathLeft,
  leftBtnSrc,
  title,
  rightBtnSrc,
  pathRight,
  buttonStyle = {},
  onBackButtonClick
}) => {
  const navigate = useNavigate()
  const theme = useTheme()

  return (
    <div className="flex items-center" style={buttonStyle}>
      <Button
        onClick={
          onBackButtonClick
            ? onBackButtonClick
            : () => navigate(pathLeft ? pathLeft : -1)
        }
        color={theme?.app?.background}
        className="mr-3"
        background={'transparent'}
        padding={'unset'}
      >
        <img src={leftBtnSrc ? leftBtnSrc : theme?.app?.backBtn} />
      </Button>
      {title && <Text color={theme?.app?.text}>{title ? title : ''}</Text>}
      {rightBtnSrc && (
        <Button
          onClick={() => navigate(pathRight)}
          className=" mr-3"
          background={'transparent'}
          padding={'unset'}
          style={{ color: theme?.app?.text }}
        >
          <img src={rightBtnSrc} />
        </Button>
      )}
    </div>
  )
}

export default BackButton
